import { Component, Input } from '@angular/core';

@Component({
  selector: 'digicem-product-accordion',
  templateUrl: './product-accordion.component.html',
})
export class ProductAccordionComponent {
  @Input() public title: string = '';
  @Input() public productName: string = '';
  @Input() public quantityText: string = '';

  protected isOpen = false;

  protected toggleAccordion(): void {
    this.isOpen = !this.isOpen;
  }
}
